export default function AboutSection() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200/60 text-xs font-medium text-foreground-500 tracking-wide uppercase">
          Why Sugargoo Spreadsheet
        </span>

        <div className="mt-8 space-y-4">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            Discover the
            <span className="inline-flex items-center gap-2 mx-2 align-middle">
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-accent-100 rounded-lg">
                <i className="ri-footprint-line text-xl md:text-2xl text-accent-600"></i>
              </span>
            </span>
            power of
          </h2>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            curated
            <span className="inline-flex items-center gap-2 mx-2 align-middle">
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-secondary-100 rounded-lg">
                <i className="ri-t-shirt-line text-xl md:text-2xl text-secondary-600"></i>
              </span>
            </span>
            spreadsheet shopping
          </h2>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            with verified
            <span className="inline-flex items-center gap-2 mx-2 align-middle">
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-accent-100 rounded-lg">
                <i className="ri-shopping-bag-3-line text-xl md:text-2xl text-accent-600"></i>
              </span>
            </span>
            seller links
          </h2>
        </div>

        <p className="mt-10 text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          Every link in our spreadsheets has been hand-picked by experienced community members. No guesswork, no dead ends — just direct paths to the best products from trusted Sugargoo sellers.
        </p>
      </div>
    </section>
  );
}